import template from './main.html';
import controller from './main.controller.js';

const OrderAndPayMainComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default OrderAndPayMainComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/main/main.component.js
 **/